<div class="d-flex flex-column flex-sm-row justify-content-between pb-1">
  <div class="d-flex align-items-center gap-2 flex-grow-1">
    <ng-container *ngIf="actionLinks[0]?.asset?.type === 'icon' && !actionLinks[0]?.title">
      <a
        floAnalytics
        [analyticsProperties]="actionLinks[0].analytics"
        data-test="back-link"
        (click)="ctaClick(actionLinks[0])"
      >
        <flo-svg-icon
          [ngClass]="actionLinks[0].asset?.style | floCssClassSanitize"
          [icon]="actionLinks[0].asset?.style"
          class="d-flex text-900"
          width="24px"
          height="24px"
          data-test="back-icon-link"
        ></flo-svg-icon>
      </a>
    </ng-container>
    <div class="d-flex justify-content-between align-items-center w-100">
      <h2 class="h5 mb-0">{{ title }}</h2>
      <span
        *ngIf="cta"
        class="footnote color-500 cursor-pointer hover-underline"
        data-test="cta"
        (click)="ctaClick($event)"
        >{{ cta }}
      </span>
    </div>
  </div>
  <div class="d-flex gap-3 align-items-center justify-content-between w-100 w-sm-auto mt-2 mt-sm-0" *ngIf="actionLinks.length > 0">
    <ng-container *ngFor="let actionLink of actionLinks">
      <a
        *ngIf="actionLink?.url && actionLink?.title && (actionLink.asset?.type !== 'icon' || actionLink?.title)"
        floAnalytics
        [analyticsProperties]="actionLink.analytics"
        [attr.href]="actionLink.url"
        [attr.target]="actionLink.target || null"
        [attr.rel]="actionLink.target === '_blank' ? 'noopener noreferrer' : null"
        data-test="link-title"
        [ngClass]="actionLink.style === 'button:text-primary' ? 'btn-text-primary d-flex align-items-center gap-1' : 'footnote color-500 hover-underline hover-grey-500 mb-0 pe-3 pe-sm-0'"
        (click)="ctaClick(actionLink)"
      >
        <flo-svg-icon
          *ngIf="actionLink.asset?.type === 'icon'"
          [icon]="actionLink.asset?.style"
          width="20px"
          height="20px"
        ></flo-svg-icon>
        <span>{{ actionLink.title }}</span>
        <flo-svg-icon
          *ngIf="actionLink.secondaryAsset?.type === 'icon'"
          [icon]="actionLink.secondaryAsset?.style"
          width="20px"
          height="20px"
        ></flo-svg-icon>
      </a>
    </ng-container>
  </div>
</div>